import React, { useState } from "react";
import {
  Dialog,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CreateSupportRequestModal = ({ show, onClose, onSubmit, isSubmitting = false }) => {
  const [formData, setFormData] = useState({
    subject: "",
    message: "",
  });

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.subject.trim() && formData.message.trim()) {
      const submitted = await onSubmit(formData);
      if (submitted) {
        setFormData({
          subject: "",
          message: "",
        });
      }
    }
    onClose();
  };

  const handleClose = () => {
    setFormData({
      subject: "",
      message: "",
    });
    onClose();
  };

  return (
    <Dialog
      open={show}
      onClose={isSubmitting ? undefined : handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1,
        },
      }}
    >
      <div className="pb-0 pr-16 px-6 pt-4">
        <h2 className="text-xl font-bold text-primary">
          Create New Support Request
        </h2>
        <p className="text-sm text-muted mt-1">
          Fill out the form below and we'll respond within 24 hours.
        </p>
        <IconButton
          onClick={handleClose}
          disabled={isSubmitting}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: "grey.500",
          }}
        >
          <CloseIcon />
        </IconButton>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="pt-6 px-6 space-y-4">
          <TextField
            label="Subject"
            type="text"
            value={formData.subject}
            onChange={handleChange("subject")}
            placeholder="Enter support request subject"
            fullWidth
            required
            variant="outlined"
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="Message"
            multiline
            rows={6}
            value={formData.message}
            onChange={handleChange("message")}
            placeholder="Provide a detailed description of your issue"
            fullWidth
            required
            variant="outlined"
            InputLabelProps={{ shrink: true }}
          />
        </div>

        <div className="flex justify-end gap-3 px-6 py-4">
          <Button
            type="submit"
            variant="contained"
            disabled={isSubmitting}
            sx={{
              bgcolor: "#0A2342",
              "&:hover": { bgcolor: "#0A2342" },
              textTransform: "uppercase",
              fontWeight: 600,
              px: 3,
            }}
          >
            {isSubmitting ? "Sending..." : "Send Request"}
          </Button>
        </div>
      </form>
    </Dialog>
  );
};

export default CreateSupportRequestModal;
